module.exports = __webpack_public_path__ + "img/i_h_like_on.976b15a4.svg";